import { render } from "./BuildingCom.vue?vue&type=template&id=424e0e60&scoped=true"
const script = {}

import "./BuildingCom.vue?vue&type=style&index=0&id=424e0e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424e0e60"]])

export default __exports__